import RelativeTime from '../../../common/components/relative-time/relative-time';
import StatusPill from '../../../common/components/status-pill/status-pill';
import { ROUND_STATE_LABEL, ROUND_STATE_TONE } from '../../../core/constants/domain';

import '../styles/round-history.css';

export default function RoundHistory({ rounds }) {
    return (
        <ol className="round-history">
            {rounds.map((round) => (
                <li key={round.id} className="round-history__round">
                    <div className="round-history__head">
                        <span className="round-history__number">Ronda {round.number}</span>
                        <StatusPill tone={ROUND_STATE_TONE[round.state]}>{ROUND_STATE_LABEL[round.state] ?? round.state}</StatusPill>
                    </div>
                    <dl className="round-history__facts">
                        <div>
                            <dt>Entregó</dt>
                            <dd>{round.deliveredBy ?? '—'} · <RelativeTime value={round.deliveredAt} /></dd>
                        </div>
                        <div>
                            <dt>Commits</dt>
                            <dd className="mono">{round.baseCommit ?? '—'} → {round.deliveredCommit ?? '—'}</dd>
                        </div>
                        <div>
                            <dt>Hallazgos</dt>
                            <dd>
                                {round.summary.cumple} cumplen · {round.summary.incumple} incumplen · {round.summary.no_comprobado} sin comprobar
                            </dd>
                        </div>
                        {round.decision && (
                            <div>
                                <dt>Decisión</dt>
                                <dd>
                                    {round.decision.decidedBy ?? '—'} · <RelativeTime value={round.decision.decidedAt} />
                                    {round.decision.reason && <q className="round-history__reason">{round.decision.reason}</q>}
                                </dd>
                            </div>
                        )}
                    </dl>
                </li>
            ))}
        </ol>
    );
}
